import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class CancelSubscriptionArgs {
  @Field(t => Int, { nullable: true })
  reason?: number

  @Field({ nullable: true })
  reasonDescription?: string
}
